module.exports = __webpack_public_path__ + "static/media/AboutImage.7a1aeb80.png";